import { render, staticRenderFns } from "./CalDavSettings.vue?vue&type=template&id=498d90c0&scoped=true&"
import script from "./CalDavSettings.vue?vue&type=script&lang=js&"
export * from "./CalDavSettings.vue?vue&type=script&lang=js&"
import style0 from "./CalDavSettings.vue?vue&type=style&index=0&id=498d90c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d90c0",
  null
  
)

export default component.exports